import React from "react";

import classnames from "classnames";
import SquareLogo from "images/logos/square.png";
import AnthemLogo from "images/provider-logos/anthem-blue-cross.png";
import BlueShieldLogo from "images/provider-logos/blue-cross-blue-shield.png";
import HumanaLogo from "images/provider-logos/humana.png";
import KaiserLogo from "images/provider-logos/kaiser-permanente.png";
import UnitedLogo from "images/provider-logos/unitedhealthcare.png";
import SimplyInsuredLogo from "images/simplyinsured-logo-headercolor.png";
import isIntuit from "Intuit/isIntuit";
import { showOverlay } from "QuotePage/Selectors";
import { connect } from "react-redux";
import isSquare from "Square/isSquare";

import Header from "Cobalt/Header";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("LoadingOverlay");

type Props = {
  showOverlay: boolean;
};

type State = {
  message: string;
};

export class LoadingOverlayDumb extends React.Component<Props, State> {
  state: State = {
    message: isIntuit()
      ? "Importing your employee ages from QuickBooks for an exact quote..."
      : isSquare()
        ? "Importing your employee ages from Square for an exact quote..."
        : "Searching 150+ Plans...",
  };

  render() {
    return (
      this.props.showOverlay && (
        <div className={bem()}>
          {isSquare() ? (
            <div className={bem("Container")}>
              <div className={bem("Content")}>
                <Header level={7} className={bem("header")}>
                  {this.state.message}
                </Header>
                <img className={classnames(bem("Partner"), bem("Partner", "Square"))} alt="Square Inc." style={{ height: "30px" }} src={SquareLogo} />

                <Icon
                  icon="long-arrow-alt-right"
                  flavor="solid"
                  className={classnames("faa-passing", "animated")}
                  style={{
                    fontSize: "1.3em",
                    position: "relative",
                    top: "3px",
                  }}
                  mb={5}
                  ml={5}
                  mr={5}
                  mt={5}
                />

                <img alt="SimplyInsured" className="ResponsiveTopBar__Logo" style={{ height: "30px" }} src={SimplyInsuredLogo} />
              </div>
            </div>
          ) : (
            <div className={bem("Container")}>
              <div className={bem("Content")}>
                <Header level={7} className={bem("header")}>
                  {this.state.message}
                </Header>
                <div>
                  <img className={bem("image")} alt="UnitedHealthcare" src={UnitedLogo} />

                  <img className={bem("image")} alt="Humana" src={HumanaLogo} />

                  <img className={bem("image")} alt="BCBS" src={BlueShieldLogo} />

                  <img className={bem("image")} alt="Kaiser Permanente" src={KaiserLogo} />

                  <img className={bem("image")} alt="Anthem Blue Cross" src={AnthemLogo} />
                </div>
              </div>
            </div>
          )}
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  showOverlay: showOverlay(state),
});

const LoadingOverlay = connect(mapStateToProps)(LoadingOverlayDumb);

export default LoadingOverlay;
